import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { explorerUrl } from '../const/urls';

export type DemoGame = 'bellsn8ke' | 'astercoins'

interface IGameState {
  gameUrl: string;
  demoGame?: DemoGame
}

const initialState: IGameState = {
  gameUrl: '',
}

export const bellSn8keUrl = `${explorerUrl}3b8c42c8c902c2b44aaee9b63f4db7b96fabe986239ad78f5911dadd376b7c1i0`
export const astercoinsUrl = ''

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setGameUrl: (state, action: PayloadAction<string>) => {
      state.gameUrl = action.payload;
    },
    setDemoGame: (state, action: PayloadAction<DemoGame>) => {
      state.demoGame = action.payload;
    },
  },
})

export const { setGameUrl, setDemoGame } = gameSlice.actions

export default gameSlice.reducer